export const UPDATE = "appointments/UPDATE";
export const APPEND = "appointments/APPEND";
export const UPDATE_ONE = "appointments/UPDATE_ONE";
export const DESTROY = "appointments/DESTROY";
export const LOADING = "appointments/LOADING";
